import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46844c59&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=46844c59&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46844c59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46844c59')) {
      api.createRecord('46844c59', component.options)
    } else {
      api.reload('46844c59', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=46844c59&scoped=true", function () {
      api.rerender('46844c59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableEncapsulation/index.vue"
export default component.exports